import { createStudySession } from "./create-study-session"
import { updateStudySession } from "./update-study-session"
export const lessons = {
  createStudySession,
  updateStudySession,
}
